import React, { useEffect, useRef, useState } from 'react';
import '../styles/ProductsHeroSection.scss';
import { useModal } from './ModalContext';
interface ProductsHeroSectionProps {
    title: string;
    description: string;
    imageSrc: string;
}

type GridCell = {
    index: number;
    row: number;
    col: number;
    columns: number;
    rows: number;
};
const Mouse = `${process.env.REACT_APP_S3_URL}Computer%20Mouse.svg`; // Encoding space as %20
const MouseDir = `${process.env.REACT_APP_S3_URL}mouseDirection.png`;
const PhoneWithUPI = `${process.env.REACT_APP_S3_URL}phonewithUPI.png`;
const Rupee = `${process.env.REACT_APP_S3_URL}RupeeIcon.png`;
const Purse = `${process.env.REACT_APP_S3_URL}PurseIcon.png`;
const Arrow = `${process.env.REACT_APP_S3_URL}RightArrowRedBg.svg`;
const CardHoverIcon = `${process.env.REACT_APP_S3_URL}CardHoverIcon.svg`;
const LockHoverIcon = `${process.env.REACT_APP_S3_URL}LockHoverIcon.svg`;
const QRHoverIcon = `${process.env.REACT_APP_S3_URL}QRHoverIcon.svg`;
const ShieldHoverIcon = `${process.env.REACT_APP_S3_URL}ShieldHoverIcon.svg`;
const WalletHoverIcon = `${process.env.REACT_APP_S3_URL}WalletHoverIcon.svg`;
const RupeeHoverIcon = `${process.env.REACT_APP_S3_URL}RupeeHoverIcon.svg`;
const ProductsHeroSection: React.FC<ProductsHeroSectionProps> = ({
    title,
    description,
    imageSrc = PhoneWithUPI,
}) => {
    const { openModal } = useModal();
    const [gridCells, setGridCells] = useState<GridCell[]>([]); // Update state type to hold GridCell objects
    const [hoveredCount, setHoveredCount] = useState(0); // Count of hovered cells
    const [cellsWithIcons, setCellsWithIcons] = useState<{ index: number, icon: string }[]>([]); // Cells that have icons
    const containerRef = useRef<HTMLDivElement>(null);
    const [selectIcon, setSelectIcon] = useState(0);

    // Paths to your icons
    const icons = [
        CardHoverIcon,
        LockHoverIcon,
        QRHoverIcon,
        ShieldHoverIcon,
        WalletHoverIcon,
        RupeeHoverIcon,
    ];

    const calculateVisibleCells = () => {
        if (containerRef.current) {
            const containerWidth = containerRef.current.offsetWidth;
            const containerHeight = containerRef.current.offsetHeight;

            // Define the size of each cell (assuming each grid cell is 70px)
            const cellSize = 70;

            // Calculate how many rows and columns fit into the container
            const columns = Math.floor(containerWidth / cellSize);
            const rows = Math.floor(containerHeight / cellSize);

            // Generate the grid based on visible rows and columns
            const newGridCells = Array.from({ length: rows * columns }, (_, index) => {
                const row = Math.floor(index / columns);
                const col = index % columns;
                const opacity = calculateOpacity(row, col, rows, columns);
                return {
                    index,
                    row,
                    col,
                    columns,
                    rows,
                    opacity,
                };
            });

            setGridCells(newGridCells);// Update the state with the visible grid cells
        }
    };

    useEffect(() => {
        // Calculate grid cells on component mount and window resize
        calculateVisibleCells();
        window.addEventListener('resize', calculateVisibleCells);

        return () => {
            window.removeEventListener('resize', calculateVisibleCells);
        };
    }, []);

    const calculateOpacity = (row: number, col: number, rows: number, columns: number) => {
        // Reference point is the bottom-left corner [rows-1, 0] (e.g., [9,0] in the 10x22 example)
        const bottomLeftRow = rows - 1;
        const bottomLeftCol = 0;
    
        // Max possible Manhattan distance from the bottom-left corner to the farthest corner (top-right)
        const maxDistance = bottomLeftRow + (columns - 1); // This is the longest path (Manhattan distance)
    
        // Calculate Manhattan distance from the current cell to the bottom-left corner
        const distance = Math.abs(row - bottomLeftRow) + Math.abs(col - bottomLeftCol);
    
        // Normalize the opacity: when distance is 0, opacity = 1.0; when distance is maxDistance, opacity = 0.1
        const normalizedOpacity = 1 - (distance / maxDistance) * 0.9;
    
        // Ensure the opacity is at least 0.1
        return Math.max(0.1, normalizedOpacity);
    };

    const handleHover = (index: number) => {
        // Only count if the cell has not been assigned an icon
        if (!cellsWithIcons.some(cell => cell.index === index)) {
            setHoveredCount(prevCount => prevCount + 1);
        }

        // If the hovered count reaches 6, assign the next icon in sequence
        if (hoveredCount + 1 === 6) {
            
            const nextIcon = icons[selectIcon % icons.length]; // Cycle through icons
            setSelectIcon((prev) => prev + 1);
            setCellsWithIcons(prev => [...prev, { index, icon: nextIcon }]);
            setHoveredCount(0); // Reset the count after every 5th hover

            // Set a timeout to remove the icon after 3 seconds
            setTimeout(() => {
                setCellsWithIcons(prev => prev.filter(cell => cell.index !== index));
            }, 2000);
        }
    };


    return (
        <div className="main-container" ref={containerRef}>
            {gridCells.map(({ index, row, col, columns, rows }) => (
                <div
                    key={index}
                    className={`grid-cell ${cellsWithIcons.some(cell => cell.index === index) ? 'show-icon' : ''}`}
                    onMouseEnter={() => handleHover(index)}
                    style={{ '--hover-opacity': calculateOpacity(row, col, rows, columns) } as React.CSSProperties}
                >
                    {cellsWithIcons.some(cell => cell.index === index) && (
                        <img
                            src={cellsWithIcons.find(cell => cell.index === index)?.icon}
                            alt="icon"
                            className="icon-img"
                        />
                    )}
                </div>
            ))}
            <section className="products-hero-section">
                <div className='section-left'>
                    <h1>{title}</h1>
                    <h2>{description}</h2>
                    <button className="cta-button-action" onClick={openModal}>
                        <div className='align-proper'>
                            <span className='button-name-cta'>
                            Schedule a demo &nbsp;&nbsp;
                            </span>
                            <img className='arrow-icon' src={Arrow} alt='' />
                        </div>
                    </button>
                </div>
                <div className='section-right'>
                    <img 
                    className='phone-image'
                    src={imageSrc} alt='UPI' />
                </div>
                <div className="scroll-indicator">
                    <div>
                        <div className="mouse-icon">
                            <img src={Mouse} alt="Mouse Icon" />
                            <img className='mouse-direction' src={MouseDir} alt='Mouse Direction' />
                        </div>
                    </div>
                    <span style={{ color: '#8E757B'}}>Scroll Down</span>
                </div>
            </section>
        </div>
    );
};

export default ProductsHeroSection;
